<template>
    <FormControl
        label="Trigger"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Automation_Store_TriggerType,
            )
        "
    >
        <SelectInput
            :name="RequestBodyKeyEnum.App_Automation_Store_TriggerType"
        >
            <option
                v-for="triggerType in AutomationTriggerTypeEnumList"
                :value="triggerType.key"
            >
                {{ triggerType.label }}
            </option>
        </SelectInput>
    </FormControl>

    <FormControl
        label="Action"
        :error="
            errors?.getValidationError(
                RequestBodyKeyEnum.App_Automation_Store_ActionType,
            )
        "
    >
        <SelectInput :name="RequestBodyKeyEnum.App_Automation_Store_ActionType">
            <option
                v-for="actionType in AutomationActionTypeEnumList"
                :value="actionType.key"
            >
                {{ actionType.label }}
            </option>
        </SelectInput>
    </FormControl>
</template>

<script setup lang="ts">
    import { type PropType } from 'vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import ApiFormErrors from '@/Shared/Component/Forms/ApiFormErrors'
    import {
        AutomationActionTypeEnumList,
        AutomationTriggerTypeEnumList,
    } from '@/Shared/AutoGenerated/Main'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import SelectInput from '@/Shared/Component/Forms/SelectInput.vue'

    const props = defineProps({
        errors: {
            type: [Object, null] as PropType<ApiFormErrors | null>,
            required: true,
        },
    })
</script>
